import { render, staticRenderFns } from "./WorkflowMenu.vue?vue&type=template&id=606707d5&"
import script from "./WorkflowMenu.vue?vue&type=script&lang=ts&"
export * from "./WorkflowMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports